module.exports = __webpack_public_path__ + "img/upload_variety.a44b1929.svg";